/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './pharmacy-bill.reducer';

export const PharmacyBill = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const pharmacyBillList = useAppSelector(state => state.pharmacyBill.entities);
  const loading = useAppSelector(state => state.pharmacyBill.loading);
  const totalItems = useAppSelector(state => state.pharmacyBill.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="pharmacy-bill-heading" data-cy="PharmacyBillHeading">
        <Translate contentKey="tinyMedicRestApp.pharmacyBill.home.title">Pharmacy Bills</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.pharmacyBill.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/pharmacy-bill/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.pharmacyBill.home.createLabel">Create new Pharmacy Bill</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.pharmacyBill.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {pharmacyBillList && pharmacyBillList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('billNumber')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.billNumber">Bill Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billNumber')} />
                </th>
                <th className="hand" onClick={sort('billDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.billDate">Bill Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billDate')} />
                </th>
                <th className="hand" onClick={sort('totalCost')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.totalCost">Total Cost</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('totalCost')} />
                </th>
                <th className="hand" onClick={sort('discount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.discount">Discount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discount')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('timestampentry')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.timestampentry">Timestampentry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampentry')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('lastupdated')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.lastupdated">Lastupdated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastupdated')} />
                </th>
                <th className="hand" onClick={sort('cgst')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.cgst">Cgst</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cgst')} />
                </th>
                <th className="hand" onClick={sort('sgst')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.sgst">Sgst</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('sgst')} />
                </th>
                <th className="hand" onClick={sort('patientType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.patientType">Patient Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('patientType')} />
                </th>
                <th className="hand" onClick={sort('discountType')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.discountType">Discount Type</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discountType')} />
                </th>
                <th className="hand" onClick={sort('discountRemark')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.discountRemark">Discount Remark</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discountRemark')} />
                </th>
                <th className="hand" onClick={sort('verified')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.verified">Verified</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('verified')} />
                </th>
                <th className="hand" onClick={sort('referedByName')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.referedByName">Refered By Name</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referedByName')} />
                </th>
                <th className="hand" onClick={sort('referralComments')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.referralComments">Referral Comments</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('referralComments')} />
                </th>
                <th className="hand" onClick={sort('billFor')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.billFor">Bill For</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billFor')} />
                </th>
                <th className="hand" onClick={sort('orderStatus')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.orderStatus">Order Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('orderStatus')} />
                </th>
                <th className="hand" onClick={sort('roundOffVal')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.roundOffVal">Round Off Val</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('roundOffVal')} />
                </th>
                <th className="hand" onClick={sort('billForId')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.billForId">Bill For Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('billForId')} />
                </th>
                <th className="hand" onClick={sort('cessAmount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.cessAmount">Cess Amount</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cessAmount')} />
                </th>
                <th className="hand" onClick={sort('amended')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.amended">Amended</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('amended')} />
                </th>
                <th className="hand" onClick={sort('printed')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.printed">Printed</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('printed')} />
                </th>
                <th className="hand" onClick={sort('printCount')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.printCount">Print Count</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('printCount')} />
                </th>
                <th className="hand" onClick={sort('physicalReceipt')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.physicalReceipt">Physical Receipt</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('physicalReceipt')} />
                </th>
                <th className="hand" onClick={sort('discountApprovedBy')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.discountApprovedBy">Discount Approved By</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('discountApprovedBy')} />
                </th>
                <th className="hand" onClick={sort('voided')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.voided">Voided</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voided')} />
                </th>
                <th className="hand" onClick={sort('voidedReason')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.voidedReason">Voided Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedReason')} />
                </th>
                <th className="hand" onClick={sort('voidedDate')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.voidedDate">Voided Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('voidedDate')} />
                </th>
                <th className="hand" onClick={sort('appliedCategoryCode')}>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.appliedCategoryCode">Applied Category Code</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('appliedCategoryCode')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.pharmacy">Pharmacy</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.glucoUser">Gluco User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.pharmacist">Pharmacist</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.admission">Admission</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.billPriscription">Bill Priscription</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.scheme">Scheme</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.patientCategory">Patient Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.consumer">Consumer</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.amendedFrom">Amended From</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.amendedTo">Amended To</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.invoiceType">Invoice Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.pharmacyBill.appliedCategory">Applied Category</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {pharmacyBillList.map((pharmacyBill, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/pharmacy-bill/${pharmacyBill.id}`} color="link" size="sm">
                      {pharmacyBill.id}
                    </Button>
                  </td>
                  <td>{pharmacyBill.billNumber}</td>
                  <td>{pharmacyBill.billDate}</td>
                  <td>{pharmacyBill.totalCost}</td>
                  <td>{pharmacyBill.discount}</td>
                  <td>{pharmacyBill.active ? 'true' : 'false'}</td>
                  <td>{pharmacyBill.cursor}</td>
                  <td>{pharmacyBill.timestampentry}</td>
                  <td>{pharmacyBill.microSec}</td>
                  <td>{pharmacyBill.lastupdated}</td>
                  <td>{pharmacyBill.cgst}</td>
                  <td>{pharmacyBill.sgst}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.PatientType.${pharmacyBill.patientType}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.DiscountType.${pharmacyBill.discountType}`} />
                  </td>
                  <td>{pharmacyBill.discountRemark}</td>
                  <td>{pharmacyBill.verified ? 'true' : 'false'}</td>
                  <td>{pharmacyBill.referedByName}</td>
                  <td>{pharmacyBill.referralComments}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.BillFor.${pharmacyBill.billFor}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.OrderStatus.${pharmacyBill.orderStatus}`} />
                  </td>
                  <td>{pharmacyBill.roundOffVal}</td>
                  <td>{pharmacyBill.billForId}</td>
                  <td>{pharmacyBill.cessAmount}</td>
                  <td>{pharmacyBill.amended ? 'true' : 'false'}</td>
                  <td>{pharmacyBill.printed ? 'true' : 'false'}</td>
                  <td>{pharmacyBill.printCount}</td>
                  <td>{pharmacyBill.physicalReceipt}</td>
                  <td>{pharmacyBill.discountApprovedBy}</td>
                  <td>{pharmacyBill.voided ? 'true' : 'false'}</td>
                  <td>{pharmacyBill.voidedReason}</td>
                  <td>{pharmacyBill.voidedDate}</td>
                  <td>{pharmacyBill.appliedCategoryCode}</td>
                  <td>
                    {pharmacyBill.pharmacy ? <Link to={`/pharmacy/${pharmacyBill.pharmacy.id}`}>{pharmacyBill.pharmacy.id}</Link> : ''}
                  </td>
                  <td>
                    {pharmacyBill.glucoUser ? <Link to={`/gluco-user/${pharmacyBill.glucoUser.id}`}>{pharmacyBill.glucoUser.id}</Link> : ''}
                  </td>
                  <td>
                    {pharmacyBill.pharmacist ? (
                      <Link to={`/pharmacist/${pharmacyBill.pharmacist.id}`}>{pharmacyBill.pharmacist.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.admission ? <Link to={`/admission/${pharmacyBill.admission.id}`}>{pharmacyBill.admission.id}</Link> : ''}
                  </td>
                  <td>
                    {pharmacyBill.billPriscription ? (
                      <Link to={`/prescription/${pharmacyBill.billPriscription.id}`}>{pharmacyBill.billPriscription.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.scheme ? <Link to={`/payment-scheme/${pharmacyBill.scheme.id}`}>{pharmacyBill.scheme.id}</Link> : ''}
                  </td>
                  <td>
                    {pharmacyBill.patientCategory ? (
                      <Link to={`/patient-category/${pharmacyBill.patientCategory.id}`}>{pharmacyBill.patientCategory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.consumer ? <Link to={`/pharmacy/${pharmacyBill.consumer.id}`}>{pharmacyBill.consumer.id}</Link> : ''}
                  </td>
                  <td>
                    {pharmacyBill.amendedFrom ? (
                      <Link to={`/pharmacy-bill/${pharmacyBill.amendedFrom.id}`}>{pharmacyBill.amendedFrom.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.amendedTo ? (
                      <Link to={`/pharmacy-bill/${pharmacyBill.amendedTo.id}`}>{pharmacyBill.amendedTo.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.invoiceType ? (
                      <Link to={`/clinical-dictionary/${pharmacyBill.invoiceType.id}`}>{pharmacyBill.invoiceType.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {pharmacyBill.appliedCategory ? (
                      <Link to={`/hospital-patient-attribute/${pharmacyBill.appliedCategory.id}`}>{pharmacyBill.appliedCategory.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/pharmacy-bill/${pharmacyBill.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/pharmacy-bill/${pharmacyBill.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/pharmacy-bill/${pharmacyBill.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.pharmacyBill.home.notFound">No Pharmacy Bills found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={pharmacyBillList && pharmacyBillList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PharmacyBill;
